<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import AppraisalExerciseForm from "../../../components/performance/appraisalexercise/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": AppraisalExerciseForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('appraisalexerciserecords.createnewappraisalexercisesetup'),
      pageTitleValue: "",
      formData: {
        appexercisecode: null,
        appexercisedesc: null,
        assessmenttypeid : null,
        startdate : null,
        enddate: null,
        rankingsetid: null,
        remarks: null,
      
        stamp: 0,
        userid: this.$store.getters.userId,
      },


      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      // Convert boolean to integer. 1 = true, 0 = false
      if (
        this.formData.isincrementpost == false ||
        this.formData.isincrementpost == null
      ) {
        this.formData.isincrementpost = 0;
      } else {
        this.formData.isincrementpost = 1;
      }

      if (
        this.formData.isbonuspost == false || 
        this.formData.isbonuspost == null
      ) {
        this.formData.isbonuspost = 0;
      } else {
        this.formData.isbonuspost = 1;
      }


      this.$store.dispatch('post', {url: "/appraisalexercise/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "appraisalexerciselist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    
    },

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    cancelHandler() {
      this.$router.push({ name: "appraisalexerciselist" });
    },
  },
};
</script>